export function buildEventEmitter<EventNames extends string>() {
  const listeners = {} as Record<EventNames, (() => void)[]>
  return {
    on(event: EventNames, listener: () => void) {
      if (!listeners[event]) {
        listeners[event] = []
      }
      listeners[event].push(listener)
      return () => {
        listeners[event] = listeners[event].filter(l => l !== listener)
      }
    },
    trigger(event: EventNames) {
      if (listeners[event]) {
        listeners[event].forEach(l => l())
      }
    },
  }
}
